import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'

import { connect } from 'react-redux'

//import { handleSaveAssignedBuildings } from '../../actions/users'
import t from '../../utils/lang/user'

const styles = theme => ({

});

class DeleteUserDialog extends Component {
  render() {
    const { open, handleClose, handleDeleteUser, classes } = this.props

    const lang = 'en'

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{t[lang].deleteUser}</DialogTitle>
        <DialogContent>
          <Typography>{t[lang].deleteUserConfirmation}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t[lang].cancel}
          </Button>
          <Button onClick={handleDeleteUser} color="secondary" autoFocus>
            {t[lang].delete}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

DeleteUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDeleteUser: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
};

export default connect()(withStyles(styles)(DeleteUserDialog))


// WEBPACK FOOTER //
// ./src/components/Users/DeleteUserDialog.js